<template lang="pug">
.intro-yezza
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-text.pa-5
        .h6.basic800--text.text-center(v-html="$t('track_business_profit_loss')")
        v-layout.my-8(style="height:275px; overflow: hidden;")
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/intro_ybooks.png')" width="215" contain)
        v-row.mt-4(no-gutters)
          v-col.shrink
            v-layout.mr-2(style="width: 32px; height:32px")
              v-img(:src="require('@/assets/images/icon_intro_expense.png')")
          v-col
            .s1.primary500--text {{ $t('record_income_expense') }}
            .c1.basic600--text {{ $t('record_income_expense_desc') }}
        v-row.mt-4(no-gutters)
          v-col.shrink
            v-layout.mr-2(style="width: 32px; height:32px")
              v-img(:src="require('@/assets/images/icon_intro_income.png')")
          v-col
            .s1.primary500--text {{ $t('track_profit_loss') }}
            .c1.basic600--text {{ $t('track_profit_loss_desc') }}
        v-row.mt-4(no-gutters)
          v-col.shrink
            v-layout.mr-2(style="width: 32px; height:32px")
              v-img(:src="require('@/assets/images/icon_intro_manage.png')")
          v-col
            .s1.primary500--text {{ $t('create_invoice_accept') }}
            .c1.basic600--text {{ $t('create_invoice_accept_desc') }}
        v-row.mt-4(no-gutters)
          v-col.shrink
            v-layout.mr-2(style="width: 32px; height:32px")
              v-img(:src="require('@/assets/images/icon_intro_manage.png')")
          v-col
            .s1.primary500--text {{ $t('payment_reminder') }}
            .c1.basic600--text {{ $t('payment_reminder_desc') }}

      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-medium.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' depressed height=32 @click='clickStartTrial')
          .button-AA-small.basic100--text {{ $t('start_seven_day_trial') }}
</template>

<script>
export default {
  name: "BooksIntroModal",
  props: ['company', 'open'],
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    clickStartTrial () {
      this.$emit('try')
      this.showModal = false
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "track_business_profit_loss": "Track your business' profit & loss,</br>no accounting required",
    "record_income_expense": "Record income & expense",
    "record_income_expense_desc": "Record & keep your receipt safely online just from your smartphone.",
    "track_profit_loss": "Track profit & loss",
    "track_profit_loss_desc": "Track your real-time profit & loss, all in one glance. Anywhere, anytime.",
    "create_invoice_accept": "Create invoice & accept payment",
    "create_invoice_accept_desc": "Easily create your invoice & receive payment online via payment gateway.",
    "payment_reminder": "Payment reminder",
    "payment_reminder_desc": "Stop wasting time chasing unpaid invoices, schedule your reminder with Yezza Books.",
    "start_seven_day_trial": "Start 7-day trial"
  },
  "id": {
    "track_business_profit_loss": "Track your business' profit & loss,</br>no accounting required",
    "record_income_expense": "Record income & expense",
    "record_income_expense_desc": "Record & keep your receipt safely online just from your smartphone.",
    "track_profit_loss": "Track profit & loss",
    "track_profit_loss_desc": "Track your real-time profit & loss, all in one glance. Anywhere, anytime.",
    "create_invoice_accept": "Create invoice & accept payment",
    "create_invoice_accept_desc": "Easily create your invoice & receive payment online via payment gateway.",
    "payment_reminder": "Payment reminder",
    "payment_reminder_desc": "Stop wasting time chasing unpaid invoices, schedule your reminder with Yezza Books.",
    "start_seven_day_trial": "Start 7-day trial"
  }
}
</i18n>
